import { useStyletron } from '@thanx/uikit/theme'

import Badge from 'components/Badge'
import palette from 'constants/palette'

type Props = {
  provider: string
  className?: string
}

/** The POS or ordering provider a version comes from, e.g. Toast or Olo */
const ProviderBadge = ({ provider, className = '' }: Props) => {
  const [css] = useStyletron()

  return (
    <Badge
      value={provider}
      className={`${className} ${css({
        backgroundColor: palette.grey20,
        color: palette.grey70,
      })}`}
    />
  )
}

export default ProviderBadge
